module.exports = __webpack_public_path__ + "static/media/phoenix-squadron.8b31e30b.svg";